"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagePickerStrings_en = void 0;
/* tslint:disable-next-line variable-name */
exports.languagePickerStrings_en = {
    font: 'Font',
    script: 'Script',
    language: 'Language',
    selectLanguage: 'Choose Language Details',
    findALanguage: 'Find a language by name, code, or country',
    codeExplained: 'Code Explained',
    subtags: 'Subtags',
    details: 'Details',
    languageOf: 'A Language of $1$2.',
    inScript: ' in the $1 script',
    select: 'Save',
    cancel: 'Cancel',
    phonetic: 'Phonetic'
};
